module.exports = __webpack_public_path__ + "img/cardModalTit.65b06de3.png";